import {useForm} from "@mantine/form";
import {Autocomplete, Button, Modal, ModalProps, Stack, Textarea, TextInput} from "@mantine/core";
import {TaskAPI} from "../../api/task/TaskAPI";
import { showNotification } from "@mantine/notifications";
import {useEffect, useState} from "react";
import Page from "../../models/api/Page";
import UserApi, {User} from "../../api/user/UserApi";

type Props = ModalProps;

function CreateTaskDialog(props: Props) {
    const [users, setUsers] = useState<User[]>();

    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
            title: '',
            description: ''
        },

        validate: {
            title: (t) => t.length < 2 ? 'Przynajmniej 2 znaki' : null,
        }
    });

    const onCreateFailed = () => {
        showNotification({
            title: 'Nie udało się utworzyć zadania',
            message: 'Spróbuj ponownie później',
            color: 'red'
        });
    }

    const create = (values: any) => {
        TaskAPI.create(values)
            .then(props.onClose)
            .catch(onCreateFailed);
    }

    const onReloadFailed = () => {
        showNotification({
            title: 'Nie udało się pobrać listy użytkowników',
            message: 'Spróbuj ponownie później'
        });
    }

    const reload = () => {
        UserApi.search({ })
            .then(setUsers)
            .catch(onReloadFailed);
    }

    useEffect(reload, []);

    return (
        <Modal title="Utwórz zadanie" size="xl" {...props}>
            <form onSubmit={form.onSubmit(create)}>
                <Stack>
                    <TextInput
                        withAsterisk
                        label="Tytuł"
                        placeholder="Tytuł zadania"
                        variant="filled"
                        key={form.key("title")}
                        {...form.getInputProps("title")}
                    />

                    <Textarea
                        label="Opis"
                        placeholder="Opis zadania"
                        variant="filled"
                        key={form.key("description")}
                        {...form.getInputProps("description")}
                    />

                    <Autocomplete
                        label="Przypisanie"
                        data={users?.map(u => ({ label: u.username, value: u.id })) ?? []}
                        key={form.key("assignedTo")}
                        { ...form.getInputProps("assignedTo") }
                    />

                    <Button fullWidth type="submit">
                        Utwórz
                    </Button>
                </Stack>
            </form>
        </Modal>
    )
}

export default CreateTaskDialog;